import type { MetricKey } from '../../utils/types';

export const metricsOrder: MetricKey[] = [
  'totalBidSpendInUsd',
  'relevance',
  'totalCprMarketRequests',
  'totalImpressions',
  'avgBidCpm',
  'avgViewability',
  'avgPubWinRate',
  'avgOxWinRate',
];
